export const PORTAL_DEVICE_ID_KEY = "gdi_portal_presence_device_id";

export const getOrCreatePortalDeviceId = (storage = window.localStorage) => {
    const existingDeviceId = storage.getItem(PORTAL_DEVICE_ID_KEY);
    if (existingDeviceId) {
        return existingDeviceId;
    }

    const deviceId = `portal-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    storage.setItem(PORTAL_DEVICE_ID_KEY, deviceId);
    return deviceId;
};

export const buildPortalPresencePayload = (userName, storage = window.localStorage) => ({
    user_name: userName,
    connection_type: "portal",
    app_version: (process.env.REACT_APP_BUILD_VERSION || "development").slice(0, 50),
    device_id: getOrCreatePortalDeviceId(storage),
    device_platform: (
        navigator.userAgentData?.platform || navigator.platform || "Browser"
    ).slice(0, 20),
});
